// NextScene - profile field option lists (checkbox-driven UX)

export const LANGUAGES = [
  "Hindi", "English", "Marathi", "Tamil", "Telugu", "Bengali", "Gujarati", "Kannada",
  "Malayalam", "Punjabi", "Urdu", "Odia", "Assamese", "Bhojpuri", "Maithili", "Awadhi",
  "Rajasthani", "Haryanvi", "Chhattisgarhi", "Konkani", "Manipuri", "Kashmiri", "Sindhi",
  "Dogri", "Nepali", "Tulu", "Garhwali", "Kumaoni"
];

export const AVAILABILITY_OPTIONS = [
  "Full-time", "Part-time", "Weekends only", "Evenings only",
  "Flexible hours", "Willing to travel", "Local city only", "Currently on break"
];

export const SKILLS_BY_CATEGORY = {
  actor: ["Dialogue delivery", "Expressions", "Improvisation", "Method acting", "Action", "Dance", "Singing", "Dubbing", "Comedy", "Drama", "Romance", "Villain roles"],
  singer: ["Playback", "Live performance", "Classical", "Folk", "Rap", "Ghazal", "Sufi", "Bhajan", "Pop", "Rock", "Bollywood", "Regional"],
  dancer: ["Bollywood", "Kathak", "Bharatanatyam", "Hip-hop", "Contemporary", "Folk", "Salsa", "Belly dance", "Kuchipudi", "Odissi", "Freestyle"],
  model: ["Runway", "Print", "Commercial", "Fitness", "Bridal", "Editorial", "Ramp walk", "Photoshoot"],
  "voice-artist": ["Dubbing", "Character voices", "Narration", "Ad voiceover", "Radio jockey", "Multilingual"],
  comedian: ["Standup", "Improv", "Character comedy", "Roast", "Storytelling", "Prop comedy", "Political satire"],
  poet: ["Hindi shayari", "English poetry", "Urdu shayari", "Rap", "Slam poetry", "Spoken word"],
  photographer: ["Portrait", "Wedding", "Fashion", "Wildlife", "Landscape", "Product", "Street", "Event"],
  musician: ["Guitar", "Piano", "Tabla", "Sitar", "Drums", "Flute", "Harmonium", "Violin", "Composing", "Producing"],
  painter: ["Oil", "Watercolor", "Acrylic", "Digital", "Portraits", "Landscapes", "Abstract", "Traditional"],
  magician: ["Card tricks", "Illusions", "Stage magic", "Close-up magic", "Mentalism"],
  "mimicry-artist": ["Celebrity mimicry", "Political leaders", "Animal sounds", "Multi-voice"],
  "anchor-host": ["Wedding anchor", "Corporate events", "Live shows", "Award shows", "Radio", "TV"],
  rj: ["Live shows", "Music", "Talk shows", "Regional", "Hindi", "English"],
  vj: ["Music videos", "Live shows", "Anchoring", "Interviews"],
  "standup-comedian": ["Observational", "Political", "Storytelling", "Roasts", "Improv"],
  storyteller: ["Kids stories", "Folk tales", "Motivational", "Spooky", "Podcasts"],
  writer: ["Screenplay", "Novels", "Poetry", "Blogging", "Copywriting", "Songwriting"],
  chef: ["Indian", "Continental", "Bakery", "Street food", "Fusion", "Regional specialties"],
  "makeup-artist": ["Bridal", "Fashion", "Film", "Special effects", "Regional"],
  "fashion-designer": ["Bridal wear", "Casual", "Ethnic", "Fusion", "Menswear", "Womenswear"],
  stylist: ["Bridal", "Editorial", "Personal", "Celebrity"],
  choreographer: ["Bollywood", "Classical", "Hip-hop", "Contemporary", "Wedding"],
  dj: ["Bollywood", "EDM", "Hip-hop", "House", "Wedding", "Club"],
  filmmaker: ["Direction", "Screenplay", "Editing", "Cinematography", "Short film", "Documentary"],
  cinematographer: ["Wedding", "Films", "Ads", "Music videos", "Documentary"],
  editor: ["Video", "Film", "YouTube", "Reels", "VFX", "Color grading"],
  illustrator: ["Digital", "Traditional", "Character design", "Book"],
  cartoonist: ["Editorial", "Character design", "Comic strips", "Political"],
  "tattoo-artist": ["Traditional", "Realistic", "Tribal", "Watercolor", "Minimalist", "Mandala"],
  "mehendi-artist": ["Bridal", "Arabic", "Rajasthani", "Modern", "Party"],
};

// Generic skills shown when no category-specific list is available
export const GENERIC_SKILLS = ["Team work", "Camera confidence", "Multilingual", "On-time delivery", "Travel-ready"];

export const SOCIAL_PLATFORMS = [
  { key: "instagram", label: "Instagram", placeholder: "@handle or profile URL", brand: "#E1306C" },
  { key: "youtube",   label: "YouTube",   placeholder: "Channel URL", brand: "#FF0000" },
  { key: "facebook",  label: "Facebook",  placeholder: "Profile URL", brand: "#1877F2" },
  { key: "twitter",   label: "X (Twitter)", placeholder: "@handle", brand: "#000000" },
  { key: "linkedin",  label: "LinkedIn",  placeholder: "Profile URL", brand: "#0A66C2" },
  { key: "threads",   label: "Threads",   placeholder: "@handle", brand: "#000000" },
  { key: "snapchat",  label: "Snapchat",  placeholder: "@handle", brand: "#FFFC00" },
  { key: "portfolio_url", label: "Website", placeholder: "https://your-site.com", brand: "#DC2626" },
];

// Given a pasted URL, return the platform key it belongs to (or null).
export function detectSocialUrl(url) {
  if (!url || typeof url !== "string") return null;
  const patterns = [
    { key: "instagram", re: /instagram\.com/i },
    { key: "youtube",   re: /(youtube\.com|youtu\.be)/i },
    { key: "facebook",  re: /(facebook\.com|fb\.com)/i },
    { key: "twitter",   re: /(twitter\.com|x\.com)/i },
    { key: "linkedin",  re: /linkedin\.com/i },
    { key: "threads",   re: /threads\.net/i },
    { key: "snapchat",  re: /snapchat\.com/i },
  ];
  for (const p of patterns) if (p.re.test(url)) return p.key;
  return null;
}
